var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_setup.dot)?_c('span',{staticClass:"status-dot",class:_setup.dotClazz}):_vm._e(),_c('span',{class:_setup.textHighlight?_setup.textClazz:''},[_vm._t("default",function(){return [_vm._v(_vm._s(_setup.text))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }